import React from "react";

export const MinusIcon = ({ nameOfClass }) => (
    <svg className={nameOfClass} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 12C20 12.6914 19.45 13.25 18.7692 13.25H5.23077C4.55 13.25 4 12.6914 4 12C4 11.3086 4.55 10.75 5.23077 10.75H18.7692C19.45 10.75 20 11.3086 20 12Z" fill="#264948"/>
    </svg>
);
